import { styled } from '@mui/material/styles';
import { RadioGroup, Radio } from '@mui/material';

const KeyVaultStyles = {
    provisioningBox: {
        // background: 'transparent linear-gradient(180deg, #3498DB 0%, #1A4C6E 100%) 0% 0% no-repeat padding-box',
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'scroll',
        width: (theme) => theme.spacing('100%'),
        height: (theme) => theme.spacing('100%'),
    },
    provisioning_wrapper: {
        // background: 'transparent linear-gradient(180deg, #3498DB 0%, #1A4C6E 100%) 0% 0% no-repeat padding-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: (theme) => theme.spacing('100%'),
        height: 'calc(100vh - 100px)',
    },
    circularProgressColor: { color: (theme) => theme.palette.black.dark },
    sspform_wrapper: { flexGrow: 1 },

    ProvisioningHeader: {
        pageTitle: {
            color: (theme) => theme.palette.white,
            textTransform: 'uppercase',
            fontSize: (theme) => theme.spacing(2),
            mx: (theme) => theme.spacing(0.5),
        },
        header: {
            // mx: (theme) => theme.spacing(6.625),
            mt: '25px',
        },
        gridContainer: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
        gridItem: { display: 'flex' },
        ImgSpan: { marginRight: '4px' },
        img: { width: 26 },
        catalogsApiLoadingSpan: {
            background: '#E0E0E0',
            width: 33,
            height: 33,
            marginRight: '4px',
            borderRadius: '50%',
        },
        infoIcon: { fill: '#0047BA', color: '#ffffff', fontSize: '24px', marginRight: '10px !important', marginLeft: '5px' },
    },
    stack: {
        alignItems: 'center',
        justifyContent: 'center',
    },
    costCenter: { width: '100%' },
    box: {
        bgcolor: (theme) => theme.palette.white,
    },

    envContainer: {
        // badge: { marginRight: (theme) => theme.spacing(2) },
        samBtn: {
            marginRight: (theme) => theme.spacing(2),
            // borderWidth: (theme) => theme.spacing(0.125),
            // borderStyle: 'solid',
            // borderColor: (theme) => theme.palette.cyan.main,
            // color: (theme) => theme.palette.cyan[70],
        },
        applicationBtn: {
            textTransform: 'none',
            color: (theme) => theme.palette.blue.main,
            borderWidth: (theme) => theme.spacing(0.25),
            borderStyle: 'solid',
            borderColor: (theme) => theme.palette.blue.main,
            '&:hover': {
                color: (theme) => theme.palette.cyan.main,
                borderWidth: (theme) => theme.spacing(0.25),
                borderStyle: 'solid',
                borderColor: (theme) => theme.palette.cyan.main,
                background: 'transparent',
            },
        },
        tagBtn: { textTransform: 'none' },
    },
    cartBtn: {
        width: (theme) => theme.spacing(18.75),
        height: (theme) => theme.spacing(4.375),
        textTransform: 'none',
    },
    Dialog: {
        wrapper: { display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' },
        icon: { color: '#d02424' },
        backBtn: {
            background: 'transparent',
            color: (theme) => theme.palette.interAction.$color_interaction_active,
            textTransform: 'none',
            borderRadius: (theme) => theme.palette.border.$border_radius,
            border: (theme) => `1px solid ${theme.palette.border.$color_border_secondary_button}`,
            padding: '3px 15px',
            font: (theme) => `${theme.typography.fontSize.$font_xsmall_caps} !important`,
            height: '32px',
            '&:hover': {
                color: (theme) => theme.palette.button.$color_button_primary_hover,
                border: (theme) => `1px solid ${theme.palette.background.$color_background_button_primary_hover} !important`,
                background: 'transparent',
            },
            '&:active': {
                color: (theme) => theme.palette.button.$color_button_primary_active,
                border: (theme) => `1px solid ${theme.palette.button.$color_button_primary_active} !important`,
            },
        },
        AgreeBtn: {
            marginLeft: (theme) => theme.spacing(1.25),
            padding: '3px 15px',
            font: (theme) => `${theme.typography.fontSize.$font_xsmall_caps} !important`,
            height: '32px',
            textTransform: 'none',
            borderRadius: (theme) => theme.palette.border.$border_radius,
            backgroundColor: (theme) => theme.palette.background.$color_background_button_primary,
            '&:hover': {
                backgroundColor: (theme) => theme.palette.background.$color_background_button_primary_hover,
            },
            '&:active': {
                backgroundColor: (theme) => theme.palette.button.$color_button_primary_active,
            },
        },
    },
    pricingTier: {
        radioBtnNoForm: {
            '& .css-j204z7-MuiFormControlLabel-root label': {
                marginRight: (theme) => theme.spacing(1.25),
            },
        },
        formControl: { marginLeft: '5px', height: '37.13px', justifyContent: 'center', width: '100%', marginTop: 2 },
        pricingTierBox: { color: '#0047BA', font: (theme) => theme.typography.fontSize.$font_xsmall_regular },
    },

    quickConfig: {
        spanColor: { color: '#000000' },
        labelValue: { padding: (theme) => theme.spacing(0.5, 1) },
        selectBtn: {
            marginLeft: (theme) => theme.spacing('auto'),
            display: 'flex',
            alignItems: 'flex-end',
            pr: (theme) => theme.spacing(1.5),
            pb: (theme) => theme.spacing(1.5),
        },
        selectedPaper: {
            borderWidth: (theme) => theme.spacing(0.125),
            borderStyle: 'solid',
            borderColor: (theme) => theme.palette.blue.strongDark,
        },
        paper: {
            borderColor: (theme) => theme.palette.white,
            // borderStyle: 'solid',
            // borderColor: (theme) => theme.palette.border.$color_border_input,
        },
        title: {
            font: (theme) => theme.typography.fontSize.$font_body_medium,
            width: '93%',
            flexShrink: 0,
            // fontSize: '16px',
            // fontWeight: '700',
            color: (theme) => theme.palette.textColors.$color_text_primary,
        },
        envTitle: {
            backgroundColor: '#FFF',
            borderRadius: '5px',
            '&:hover': {
                backgroundColor: (theme) => theme.palette.background.$color_background_hover,
            },
        },
        selectedBtn: {
            font: `${(theme) => theme.typography.fontSize.$font_small_bold}!important`,
            borderRadius: (theme) => theme.palette.border.$border_radius,
            backgroundColor: (theme) => theme.palette.background.$color_background_button_primary,
            // fontWeight: '700',
            color: '#fff',
            padding: '4px 16px',
            // fontSize: '14px !important',
            height: '32px',
            '&:hover': {
                backgroundColor: (theme) => `${theme.palette.background.$color_background_button_primary_hover} !important`,
            },
            '&:active': {
                backgroundColor: (theme) => `${theme.palette.button.$color_button_primary_active} !important`,
            },
            '&.Mui-disabled': {
                backgroundColor: '#003771',
                color: 'white',
            },
        },
        wrapper: {
            background: '#FBFBFB 0% 0% no-repeat padding-box',
            boxShadow: 'none',
            color: (theme) => theme.palette.white,
            borderRadius: '5px',
            // borderWidth: (theme) => theme.spacing(0.125),
            borderStyle: 'solid',
            // borderColor: (theme) => theme.palette.border.$color_border_input,
            borderTop: (theme) => `1px solid ${theme.palette.border.$color_border_divider}`,
            '&:before': {
                display: 'none',
            },
        },
        content: {
            background: (theme) => theme.palette.white,
            margin: (theme) => theme.spacing(0.25),
            marginTop: (theme) => theme.spacing(0),
            color: (theme) => theme.palette.gray[33],
            borderBottomLeftRadius: (theme) => theme.spacing(1),
            borderBottomRightRadius: (theme) => theme.spacing(1),
        },
        cirProgWrapper: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
        labeledPaper: { display: 'flex', flexDirection: 'column' },
        emptycontainer: { backgroundColor: '#FFFFFF' },
        emptymsg: { font: (theme) => theme.typography.fontSize.$font_heading_h6_medium, color: '#000000' },
        emptySuggestion: { font: (theme) => theme.typography.fontSize.$font_body_regular },
        expandIcon: { color: (theme) => theme.palette.white },
    },
    tags: {
        wrapper: { minWidth: (theme) => theme.spacing(75), width: (theme) => theme.spacing(100), display: 'flex', flexDirection: 'column', height: '100%' },
        contentWrapper: { flexGrow: 1, px: (theme) => theme.spacing(2) },
        box: { display: 'flex', flexDirection: 'column' },
        titlebox: { fontSize: (theme) => theme.spacing(1.875), display: 'flex', mb: (theme) => theme.spacing(2) },
        name: { fontWeight: 'bold', width: '31%' },
        colon: { width: (theme) => theme.spacing(0.25), mx: 1.5 },
        val: { width: (theme) => theme.spacing(50), fontWeight: 'bold', flexGrow: 1 },
        dataWrapper: { fontSize: (theme) => theme.spacing(1.875), display: 'flex', mb: (theme) => theme.spacing(1) },
        dataNameWrapper: {
            display: 'flex',
            alignItems: 'center',
            width: '30%',
            borderWidth: (theme) => theme.spacing(0.125),
            borderStyle: 'solid',

            borderRadius: (theme) => theme.spacing(0.25),
            borderColor: 'gray.lowMedium',
            py: (theme) => theme.spacing(0.5),
            px: (theme) => theme.spacing(1.5),
        },
        dataColan: { width: (theme) => theme.spacing(0.75), mx: (theme) => theme.spacing(1) },
        dataValueBoxWrapper: { flexGrow: 1 },
        actionWrapper: { display: 'flex', alignItems: 'center', justifyContent: 'flex-end', p: (theme) => theme.spacing(0.25) },
        resetBtn: {
            marginLeft: (theme) => theme.spacing(1.25),
            color: '#6E6F6F',
            textTransform: 'none',
            border: '2px solid #707070',
            '&:hover': {
                color: '#6E6F6F',
                border: '2px solid #707070',
                background: 'transparent',
            },
        },
        activeSelectField: {
            background: 'transparent',
            '& label.MuiFormLabel-filled,label.MuiInputLabel-shrink': {
                color: '#0047BA',
                padding: '0 2px',
            },
            '& label.Mui-disabled+div fieldset': {
                border: ' 1px solid #E9E9E9',
            },
            '& label.MuiFormLabel-filled+div fieldset': {
                border: ' 1px solid #0047BA',
            },
            '& label.Mui-focused+div fieldset': {
                border: ' 2px solid #0047BA !important',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#0047BA',
            },
        },
    },

    submitOrder: {
        wrapper: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' },
        orderIdTypo: { color: (theme) => theme.palette.blue.main, textDecoration: 'underline', cursor: 'pointer', mx: (theme) => theme.spacing(1) },
        actionWrapper: { textAlign: 'center', my: (theme) => theme.spacing(0.25), py: (theme) => theme.spacing(2) },
        newOrder: { marginRight: (theme) => theme.spacing(2), textTransform: 'none' },
        message: { font: (theme) => theme.typography.fontSize.$font_heading_h4_medium, color: (theme) => theme.palette.black.dark },
        description: { width: '500px', font: (theme) => theme.typography.fontSize.$font_body_regular, color: (theme) => theme.palette.black.dark },
        checkOutBtn: {
            width: '180px',
            textTransform: 'none',
            color: '#0047BA',
            border: '2px solid #0047BA',
            '&:hover': {
                color: '#00A0DD',
                borderWidth: '2px',
                border: '2px solid #00A0DD',
                backgroundColor: 'white',
            },
        },
    },
    card: {
        paper: {
            padding: (theme) => theme.spacing(2),
            background: (theme) => theme?.palette?.gray?.lighter,
            height: (theme) => theme.spacing('100%'),
        },
        form: {
            '& > *': {
                marginBottom: (theme) => theme.spacing(2.5),
            },
        },

        box: { mb: (theme) => theme.spacing(0.375) },
        typography: { marginBottom: (theme) => theme.spacing(0.25) },
    },
    disposal: {
        infoIcon: { color: (theme) => theme.palette.gray.main },
        helpText: { color: '#000000' },
    },
    keyVaultName: {
        textField: {
            width: (theme) => theme.spacing('100%'),
            '& .MuiFormHelperText-root': {
                marginTop: (theme) => theme.spacing('-2'),
            },
        },
    },
};

export const CustomRadioGroup = styled(RadioGroup)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'left',
    width: 'inherit',
    [theme.breakpoints.only('md')]: {
        fontSize: theme.spacing(1.25),
        marginRight: theme.spacing(-2.15),
    },
    '& .MuiSvgIcon-root': {
        [theme.breakpoints.only('md')]: {
            fontSize: theme.spacing(1.875),
        },
        [theme.breakpoints.only('lg')]: {
            fontSize: theme.spacing(2.25),
        },
    },
}));

export const CustomRadio = styled(Radio)(({ theme }) => ({
    [theme.breakpoints.only('md')]: {
        fontSize: theme.spacing(1.875),
    },
    [theme.breakpoints.only('lg')]: {
        fontSize: theme.spacing(2.25),
    },
}));

export default KeyVaultStyles;
